type ActivityStats = { enabled?: boolean; lastActivityAt?: number; positionLastUpdated?: number };

export function botActivity(stats: ActivityStats, now = Date.now()) {
  if (stats.enabled === false) return { state: 'disabled', message: 'Bot is disabled in configuration.' } as const;
  const timestamp = stats.lastActivityAt ?? stats.positionLastUpdated;
  if (!timestamp || !Number.isFinite(timestamp)) {
    return { state: 'unknown', message: 'No activity timestamp available. Bot status is unknown.' } as const;
  }
  const minutes = Math.max(0, Math.floor((now - timestamp) / 60_000));
  return minutes <= 15
    ? { state: 'recent', message: `Activity reported ${minutes} min ago. This does not confirm that every operation is succeeding.` } as const
    : { state: 'stale', message: `No recent activity reported (${minutes} min ago). The bot may still be working; check its current step.` } as const;
}

export function balancingStatusMessage(stats: { enabled?: boolean; currentBalancingStep?: string; currentBalancingSubStep?: string; balancingUSD?: number }) {
  if (stats.enabled === false) return 'Bot is disabled.';
  if (stats.currentBalancingStep === 'DERIBIT' && /ROI/i.test(stats.currentBalancingSubStep || '')) {
    return 'Waiting for the ROI target in Deribit. A new pool position depends on balancing completion.';
  }
  if (stats.currentBalancingStep || (stats.balancingUSD || 0) > 0) {
    return 'Balancing in progress. A new pool position depends on balancing completion.';
  }
  return 'No open pool position. Waiting for the bot to meet its opening conditions.';
}
